import axios from 'axios';
import router from '../../router';
import vue_ from '../../main'
// http://117.ci2.cn:8080/
//http://api.order.ci2.cn
const  request=axios.create({
  baseURL:CONFIG.baseURL, // api 的 base_url
  timeout: 5000000 // request timeout
})
// 添加请求拦截器
request.interceptors.request.use(config=>{
  //请求统一增加请求头
  config.headers['Content-Type'] = 'application/json'
  config.headers.common={
    "Authorization":vue_.getStorage('authorization')||''

}
  return config;
})
////添加响应拦截器
request.interceptors.response.use(res=>{
  //成功返回
  if (res.data.code === "success"||res.data.status) {
console.log('232aa')
    // 返回data
   return Promise.resolve(res.data)
  } else {
    // if (res.data.code == "604" || res.data.code == "603" || res.data.code == "605") {
    //   localStorage.clear();
    //   router.push('/login');
    // }
      console.log('232bb')
    return Promise.reject(res.data)
  }
  // return response.data
},error=>{
  //失败返回，方法返回一个带有拒绝原因reason参数的Promise对象。
  console.log(error)
  return Promise.reject(error)
})
function get(url,data){
  return request.get(url,{
    params:data
  })
}
function post(url,data) {
  return request.post(url,data)
}
export default {
  get,post
}
